$(document).foundation();

// putrid function needed to turn object outputs from date-range-picker into real JS dates
function m40GetMonth(str)
{
    switch (str){
        case "Jan":
            return "01";
            break;
        case "Feb":
            return "02";
            break;
        case "Mar":
            return "03";
            break;
        case "Apr":
            return "04";
            break;
        case "May":
            return "05";
            break;
        case "Jun":
            return "06";
            break;
        case "Jul":
            return "07";
            break;
        case "Aug":
            return "08";
            break;
        case "Sep":
            return "09";
            break;
        case "Oct":
            return "10";
            break;
        case "Nov":
            return "11";
            break;
        case "Dec":
            return "12";
            break;
    }
}

$(document).ready(function($){
    $(".vertical-tab-item").click(function() {

        var scrollTo = ($(document).find('.tabs-content').offset().top) - 50;

        $('html, body').animate({scrollTop: scrollTo}, 'slow');
    });

/*    if($('#availability-form').length)
    {
        $("#number_of_nights").on('change', function()
        {
            var numberofNights = parseInt($('#number_of_nights').val());
            var startDate = moment($("#start_date").val(), dateTimeFormat);
            var endDate = startDate.clone().add(numberofNights, "days");

            $("#end_date").val(endDate.format(dateTimeFormat));
        });

        $(".date-range-picker").dateRangePicker(calendarConfig)
            .bind('datepicker-change',function(event,obj)
            {
                //console.log(obj);
                // this code is used to present a user friendly message to the user about how many nights they've selected
                // it pulls data from the date-range-picker object, converts and compares it. It's clunky, but produces a better experience.
                // get objects and make strings
                var d1 = $("#start_date").val(startDate.format(dateTimeFormat));
                var d2 = $("#end_date").val(endDate.format(dateTimeFormat));
                // convert to arrays
                var date1_arr = d1.split(" ");
                var date2_arr = d2.split(" ");
                //convert to JS dates
                var date1 = new Date ( m40GetMonth(date1_arr[1]) + "/" + date1_arr[2] + "/" + date1_arr[3] );
                var date2 = new Date ( m40GetMonth(date2_arr[1]) + "/" + date2_arr[2] + "/" + date2_arr[3] );
                // get the difference in days
                var timeDiff = Math.abs(date2.getTime() - date1.getTime());
                var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
                diffDays++; // we add one because we have to
                // apply to page outputs
                var nightsCopy = "You have selected a <b>" + diffDays + " night</b> stay.";
                $("#availability-length-note").html(nightsCopy);
                // and now, send Database suitable dates to the hidden fields
                var formatted_date1 = (  date1_arr[3] + "-" +  m40GetMonth(date1_arr[1]) + "-" + date1_arr[2] );
                var formatted_date2 = (  date2_arr[3] + "-" +  m40GetMonth(date2_arr[1]) + "-" + date2_arr[2] );
                $('#start_date_formatted').val(formatted_date1);
                $('#end_date_formatted').val(formatted_date2);
                $('#number_of_nights').val(diffDays);
            });
    }*/

    // Search Bar
    $("#desktop-search-btn").click(function() {
        $(".desktop-search").toggleClass("open-search");
        setTimeout(function() { $('.desktop-search input').focus() }, 500);
    });

    $(".mobile-search-btn").click(function() {
        $("#mobile-search-input").toggleClass("open-search");
        setTimeout(function() { $('#mobile-search-input input').focus() }, 500);
    });
    $(document).keydown(function(event){
        if(event.keyCode == 27) {
            if ($('.desktop-search').hasClass('open-search')) {
                $('.desktop-search').removeClass('open-search');
            }
        }
        if(event.keyCode == 27) {
            if ($('#mobile-search-input').hasClass('open-search')) {
                $('#mobile-search-input').removeClass('open-search');
            }
        }
        if(event.keyCode == 27) {
            if ($('header').hasClass('push-back')) {
                $('header').removeClass('push-back');
            }
        }

    });

    // Toggle content blocks

    $( ".collapse-content-header.closed, .collapse-content-header.open" ).on('click', function() {
        //alert ($(this));
        $(this).toggleClass('closed');
        $(this).toggleClass('open');
        $(this).parent().next().slideToggle();
    });


});



$(document).ready(function(){
    if ($(window).width() < 769) {
        // console.log("window under 769px");
        $('.standard-tabs-container .tab-title').addClass('mobile-scroll');

        $(".mobile-scroll").click(function() {
            var scrollTo = ($(document).find('.tabs-content').offset().top) - 50;
            $('html, body').animate({scrollTop: scrollTo}, 'slow');
        });

    } else {
        $('.standard-tabs-container .tab-title').removeClass('mobile-scroll');
    }




});



$(document).ready(function(){
    $("li.footer-item a").on("click", function() {
        $(".footer-item a").toggleClass("active");
    })
});

// Mega Menus
$(".mega-menu-trigger").click(function(event) {
    event.preventDefault();
    menuClass = $(this).data("menu");
    $megaMenu = $(".mega-menu-container." + menuClass);

    if( !$(this).hasClass('active') )
    {
        $(".mega-menu-container").removeClass("open");
        $(".mega-menu-trigger").removeClass("active");

        $(this).addClass("active");
        $megaMenu.addClass("open");
    } else
    {
        $(".mega-menu-container").removeClass("open");
        $(".mega-menu-trigger").removeClass("active");
    }

});


// Close Mega Menu
$(".mega-menu-content .close-button").click(function(event) {
    event.preventDefault();
    $(".mega-menu-container").removeClass("open");
    $(".mega-menu-trigger").removeClass("active");
});

window.onresize = function(event) {
    $(".mega-menu-container").removeClass("open");
    $(".mega-menu-trigger").removeClass("active");
}


// more Activities Model
$(".more-activities-popup, .more-events-popup").click(function(event) {
    event.preventDefault();
    $(".more-popup-content, .more-events-popup").toggleClass("active");

});



$(".nav-icon").on('click', function(event) {
    event.preventDefault();
    $("header").toggleClass('opened');
    $('.mobile-nav-container').toggleClass('open');
    $('.nav-icon').toggleClass('open');

});





$(".containing-section-item").on('click', function(event) {

    $toggle = !$(this).hasClass('open');

    $(".containing-section-item").removeClass('open');
    $(".containing-section-item").children(".mobile-submenu-items").removeClass("opened");

    if($toggle)
    {
        $(this).addClass('open');
        $(this).children(".mobile-submenu-items").addClass("opened");
    } else {
        $(this).removeClass('open');
        $(this).children(".mobile-submenu-items").removeClass("opened");
    }

});

$(".menu-section-item").on('click', function(event) {
    event.preventDefault();
});



$(".gallery-item-clicked").on('click', function() {
    $("header").addClass('push-back');
});

$(".clearing-close").on('click', function() {
    $("header").removeClass('push-back');
});





$(".overlay-close").on('click', function() {
    $("header").removeClass('opened');
    return false;
});

$(".enquiry-close").on('click', function() {
    $(".header-enquiry-form").stop().slideUp('500').removeClass('open');
});


$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if(scroll >= 680) {
        $(".menu-container").addClass("white-bg");
    } else {
        $(".menu-container").removeClass("white-bg");
    }
});


// Our Story scroll
$(document).ready(function() {
    // When the window is scrolled
    $(window).scroll(function() {

        // Find the location of each element
        $('.fadein-content').each(function(i) {
            var bottom_of_article = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();

            // If the object is completely visible, show it
            if(bottom_of_window > bottom_of_article) {
                $(this).animate({'opacity':'1'},500);
            }
        });

        // Find the location of each element
        $('.fadein-innovation').each(function(i) {
            var top_of_article = $(this).offset().top + 160;
            var top_of_window = $(window).scrollTop() + $(window).height();

            // If the object is completely visible, show it
            if(top_of_window > top_of_article) {
                $(this).animate({'opacity':'1'},500);
            }
        });
    });
});


$("#nav-icon").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "fast");
    return false;
});




$(document).ready(function(){

    $('.combo-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true
    });

    $('.tweet-carousel').slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true
    });

    $('.testimonial-slider').slick({
        autoplay:true,
        dots:true,
        infinite:true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows:false,

    });

    $('.more-popup-content').slick({
        autoplay:false,
        dots:false,
        infinite:true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows:true,

    });

    $('.activity-slider').slick({
        autoplay:false,
        dots:true,
        infinite:true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows:false,
    });

    $('.zones-carousel').slick({
        autoplay:true,
        dots:true,
        infinite:true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows:false,
    });

    $('.client-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true
    });

    if($('.more-popup-content').length)
    {
        var currentPost = $(".more-popup-content").data('current-post');

        $(".more-popup-content .slick-slide").each(function(i)
        {
            if($(this).attr('data-post-id') == currentPost)
            {
                $('.more-popup-content').slick('slickGoTo', i - 1);
            }
        });
    }


    $('.homepage-featured-item').slick({
        autoplay:true,
        dots: true,
        infinite: true,
        autoplaySpeed: 7000,
        speed: 400,
        arrows: false,
        pauseOnHover: true,
    });

    $('.feature-slider').slick({
        autoplay:true,
        dots: true,
        infinite: true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows: false,
        pauseOnHover: true
    });

    $('.multi-slider').slick({
        autoplay:true,
        dots: true,
        infinite: true,
        autoplaySpeed: 7000,
        speed: 500,
        arrows: false,
        pauseOnHover: true,
        slide: '.multi-slide'
    });

    $('.solutions-slider').slick({
        autoplay:true,
        dots:true,
        infinite:true,
        autoplaySpeed: 5000,
        speed: 400,
        arrows:false,

    });

    $('.multi-slider-solutions').slick({
        autoplay: true,
        dots: true,
        infinite: true,
        autoplaySpeed: 7000,
        speed: 400,
        arrows: false,
        pauseOnHover: false,
    });

    $('.testimonial-slider-section').slick({
        autoplay: true,
        dots: true,
        infinite: true,
        autoplaySpeed: 7000,
        speed: 400,
        arrows: false,
        pauseOnHover: false,
    });

    $('#rotator-slider-1, #rotator-slider-2, #rotator-slider-3').slick({
        autoplay:false,
        dots:false,
        infinite:true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows:true,

    });


    if($('#rotator-slider-1').length)
    {
        var rotateToPost1 = $("#rotator-slider-1").data('current-post');
        $("#rotator-slider-1 .slick-slide").each(function(i)
        {
            if($(this).attr('data-post-id') == rotateToPost1)
            {
                $('#rotator-slider-1').slick('slickGoTo', i-1);
            }
        });
    }

    if($('#rotator-slider-2').length)
    {
        var rotateToPost2 = $("#rotator-slider-2").data('current-post');
        $("#rotator-slider-2 .slick-slide").each(function(i)
        {
            if($(this).attr('data-post-id') == rotateToPost2)
            {
                $('#rotator-slider-2').slick('slickGoTo', i-1);
            }
        });
    }

    if($('#rotator-slider-3').length)
    {
        var rotateToPost3 = $("#rotator-slider-3").data('current-post');
        $("#rotator-slider-3 .slick-slide").each(function(i)
        {
            if($(this).attr('data-post-id') == rotateToPost3)
            {
                $('#rotator-slider-3').slick('slickGoTo', i-1);
            }
        });
    }

});

$("#zones-tab-button").click(function() {

    setTimeout(function() {
        //console.log("Called after delay.");
        $('.zones-carousel')[0].slick.refresh();    

    }, 0);

});

// On swipe event
$('.feature-slider, .multi-slider-solutions').on('afterChange init', function(){
    //console.log('it worked');
    $('.content-delay').delay(500).slideToggle(2000);
});

$('.feature-slider, .multi-slider-solutions').on('beforeChange', function(){
    //console.log('it worked');
    $('.content-delay').hide();
});




// iOS sniffer
$(document).ready(function(){
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
    {
        $('html').addClass('ios-device');
    }
    else
    {
        $('html').addClass('not-ios');
    }

});




function m40_socialShare(url, winWidth, winHeight) {
    var winTop = (screen.height / 2) - (winHeight / 2);
    var winLeft = (screen.width / 2) - (winWidth / 2);
    window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);

    return false;
}


$("a.toggle-enquiry-form").on('click', function(){

    if($(".header-enquiry-form").hasClass('open'))
    {
        $(".header-enquiry-form").stop().slideUp('500').removeClass('open');
    } else {
        $(".header-enquiry-form").stop().slideDown('500').addClass('open');
    }

    return false;
});


var map = null;
$(document).ready(function(){

    if ($("#video_slide").hasClass(".video-bg-container")) {
        $("content-section-media").addClass("no-leaves");
    }

    $('.acf-map').each(function(){
        // create map
        map = new_map( $(this) );

    });

    $('.instagram-image').on('click', function(){
        var image = $(this).data('feature-image');
        var caption = $(this).data('feature-caption');
        var username = $(this).data('feature-username');
        var time = $(this).data('feature-time');

        //console.log(image, caption, username, time);

        $('#instagram-feature-image').attr('src', image);
        $('#instagram-feature-caption').html(caption);
        $('#instagram-feature-user').html(username);
        $('#instagram-feature-time').html(time);
    });

});



// THEMES - CHRISTMAS
function Flake(x,y,vx,vy,s) {
    this.x = x;
    this.y = y;
    this.vx = vx;
    this.mx = Math.abs(vx * 2);
    this.vy = vy;
    this.my = vy;
    this.s = s;
    this.seed = Math.random() * 1e12;
    ///
    var canvas = document.createElement('canvas'),
        context = canvas.getContext('2d'),
        height = canvas.height = s * 2,
        width = canvas.width = s * 2,
        grad = context.createRadialGradient(s, s, 1, s, s, s);
    grad.addColorStop(0, 'rgba(255,255,255,.66)');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    context.beginPath();
    context.arc(s, s, s, 0, Math.PI * 2, !0);
    context.fillStyle = grad;
    context.fill();
    context.closePath();

    this.img = canvas;
}
Flake.prototype = {
    constructor: Flake,
    update: function() {
        this.x += this.vx;
        this.y += this.vy;

        if( this.x > width + this.s * 2 ) {
            this.x = 0 - this.s * 2;
        }
        if( this.x < 0 - this.s * 2 ) {
            this.x = width + this.s * 2;
        }

        if( this.y > height + this.s * 2 ) {
            this.y = 0 - this.s * 2;
        }
        if( this.y < 0 - this.s * 2 ) {
            this.y = height + this.s * 2;
        }
        if( Math.abs(this.vx) > this.mx ) {
            this.vx = this.vs > 0 ? this.mx : -1 * this.mx;
        }
        // direction modification is kinda cheap... 
        this.vx += Math.sin(Date.now() + this.seed)/100;
        if( this.vy < this.my ) {
            this.vy += this.my/10;
        }
    }
};

var canvas, context, height, width, snow_count, hand_size, snow;

if($('canvas').length)
{
    setTimeout(init, 10);
}

function init() {
    canvas = document.getElementById('canvas');
    context = canvas.getContext('2d');
    height = canvas.height = document.body.offsetHeight;
    width = canvas.width = document.body.offsetWidth;

    snow_count = 128;
    hand_size = 32;
    snow = [];

    for( var i = 0; i < snow_count; i++ ) {

        var x = Math.random() * width,
            y = Math.random() * height,
            s = Math.random() * 2.5 + 2.5,
            vx = Math.random() * 2 - 1,
            vy = Math.random() + s/2.5;
        snow.push(new Flake(x,y,vx,vy,s));
    }

    canvas.onmousemove = function(e) {
        for( var i = 0; i < snow_count; i++ ) {
            var dx = snow[i].x - e.clientX,
                dy = snow[i].y - e.clientY,
                d = Math.sqrt(dx*dx + dy*dy);
            if( d < hand_size ) {
                var r = Math.atan2(dy, dx);
                snow[i].vx = 2 * Math.cos(r);
                snow[i].vy = 2 * Math.sin(r);
            }
        }
    };

    update();
    render();
}

function update() {
    for( var i = 0; i < snow_count; i++ ) {
        snow[i].update();
    }
    setTimeout(update, 1000/30);
}
function render() {
    if ($("body").hasClass("christmas")) {
        //console.log("ho ho ho");
        context.clearRect(0, 0, width, height);
        for( var i = 0; i < snow_count; i++ ) {
            context.drawImage(snow[i].img, snow[i].x - snow[i].s, snow[i].y - snow[i].s);
        }
        requestAnimationFrame(render);
    }
}

/*var mapInitialized = false

/*$(document).on('opened.fndtn.reveal', '[data-reveal]', function () {

    if(mapInitialized == false) {
        $('.footer-map').each(function(){
            // create map
            map = new_map( $(this) );

        });
    }

    mapInitialized = true;
});*/



$('.clearing-thumbs li a').on('click', function(){
    $('.footer-area, .footer-testimonial').addClass('gallery-open');
});
$('.clearing-close').on('click', function(){
    $('.footer-area, .footer-testimonial').removeClass('gallery-open');
});
$(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
        $('.footer-area, .footer-testimonial').removeClass('gallery-open');
    }
});


$(document).ready(function() {
    $('.mobile-search-btn').on('click', function(){
        $(this).toggleClass('active');
    });
});




// ISOTOPE
// init Isotope
$(document).ready(function() {
    var $grid = $('.grid').isotope({
        itemSelector: '.element-item',
        layoutMode: 'fitRows',
        getSortData: {
            name: '.name',
            symbol: '.symbol',
            number: '.number parseInt',
            category: '[data-category]',
        }
    });

    // filter functions
    var filterFns = {
        // show if name ends with -ium
        ium: function() {
            var name = $(this).find('.name').text();
            return name.match( /ium$/ );
        }
    };

    // bind filter button click
    $('#filters').on( 'click', 'button', function() {
        var filterValue = $( this ).attr('data-filter');
        // use filterFn if matches value
        filterValue = filterFns[ filterValue ] || filterValue;
        $grid.isotope({ filter: filterValue });
    });

    // change is-checked class on buttons
    $('.button-group').each( function( i, buttonGroup ) {
        var $buttonGroup = $( buttonGroup );
        $buttonGroup.on( 'click', 'button', function() {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            $( this ).addClass('is-checked');
        });
    });
});